<template>
  <div class="wrapper">
    <v-select
      v-model="selected"
      return-object
      :items="sources"
      item-text="text"
      item-value="value"
      :hide-details="true"
      :disabled="loading"
      dense
      outlined
      rounded
      append-icon="icon-arrow-down"
      full-width
      :prefix="`${$t('message.externalChanges.origin')}:`"
      :menu-props="{
        contentClass: 'external-changes-source-select__menu',
        offsetY: true
      }"
      class="external-changes-source-select"
      @input="setSource"
    >
    </v-select>
  </div>
</template>

<script>
import { EXTERNAL_CHANGES_SOURCE } from "@/enums/external-changes";

export default {
  name: "ExternalChangesSourceSelect",
  data() {
    return {
      selected: {},
      sources: [
        {
          text: this.$t(`message.common.all`),
          value: null
        },
        {
          text: this.$t(
            `message.externalChangesSources.${EXTERNAL_CHANGES_SOURCE.GMB}`
          ),
          value: EXTERNAL_CHANGES_SOURCE.GMB
        },
        {
          text: this.$t(
            `message.externalChangesSources.${EXTERNAL_CHANGES_SOURCE.EXTERNAL}`
          ),
          value: EXTERNAL_CHANGES_SOURCE.EXTERNAL
        }
      ]
    };
  },
  props: {
    loading: {
      type: Boolean
    }
  },
  created() {
    this.selected = this.sources.length ? this.sources[0] : {};
  },
  methods: {
    setSource(source) {
      this.$emit("update", source.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  max-width: 330px;
}
</style>

<style lang="scss">
.external-changes-source-select {
  flex-shrink: 0;

  &.v-text-field--outlined.v-input--dense {
    > .v-input__control {
      > .v-input__slot {
        padding-left: $spacing;
        padding-right: 0;
        min-height: 46px;
        height: 46px;
        @include font-size(14px);
        line-height: 17px;
        font-weight: normal;
      }
    }
  }

  .v-text-field__prefix,
  .v-select__selection {
    @include font-size(14px);
  }

  &.v-text-field--outlined.v-input--dense.v-input--is-focused fieldset {
    border-color: $primary;
  }

  &.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
    .v-input__append-inner {
    width: 30px;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: $spacing * 1.5;
    padding-left: $spacing;
  }

  .v-text-field__prefix {
    margin: 5px 0 3px $spacing * 1.5 !important;
  }

  .v-select__selection--comma {
    margin-left: $spacing * 1 !important;
  }

  &__menu {
    border-radius: 24px !important;

    .v-list-item {
      padding: 0 $spacing * 3;

      .v-list-item__content {
        .v-list-item__title {
          @include font-size(14px);
        }
      }
    }
  }
}
</style>
